import React from "react";
import PropTypes from "prop-types";
import DeviceListItem from "./DeviceListItem";
import { Grid, GridItem } from "@sainsburys-tech/fable";
import ErrorMessage from "../ErrorMessage";

const DeviceList = props => {
  if (props.loadFailed) {
    return <ErrorMessage />;
  }

  if (!props.devices || props.devices.length === 0) {
    return <p>It looks like there are no connected assets in this store.</p>;
  }

  return (
    <Grid cols={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 4 }}>
      {props.devices.map(device => {
        return (
          <GridItem key={device.deviceId}>
            <DeviceListItem key={device.deviceId} device={device} />
          </GridItem>
        );
      })}
    </Grid>
  );
};

DeviceList.propTypes = {
  devices: PropTypes.array,
  loadFailed: PropTypes.bool
};

export default DeviceList;
